import { z } from 'zod';

export const partnerSyncStatusResponse = z.object({
    isRunning: z.boolean(),
});

export type PartnerSyncStatusResponse = z.infer<typeof partnerSyncStatusResponse>;
